const formLang = {
  label: {
    dateFormat: {
      en: 'dd/mm/yy',
      fr: 'dd/mm/yy'
    },
    email: {
      en: 'Email Address',
      fr: 'Courriel'
    },
    subject: {
      en: 'Please Select Email Subject',
      fr: 'Please Select Email Subject (fr)'
    },
    dealerPostal: {
      en: 'Search by Postal Code or Dealer Name',
      fr: 'Recherche par code postal ou nom de concessionnaire'
    },
    firstname: {
      en: 'First Name',
      fr: 'Prénom'
    },
    lastname: {
      en: 'Last Name',
      fr: 'Nom'
    },
    postalcode: {
      en: 'Postal Code',
      fr: 'Code postal'
    },
    phone: {
      en: "Phone",
      fr: "Phone"
    },
    vin: {
      en: 'Vehicle Identification Number (VIN)',
      fr: 'Numéro d’identification du véhicule'
    },
    odometer: {
      en: 'Approx. Odometer Reading',
      fr: 'Le nombre approximatif de kilomètres inscrit à l\'odomètre'
    },
    vehicleLookUp: {
      en: 'Enter year, make and model',
      fr: 'Enter year, make and model (FR)'
    },
    kilometers: {
      en: 'Current Kilometres',
      fr: 'Current Kilometres (FR)'
    },
    model: {
      en: 'Mazda model',
      fr: 'Mazda model (fr)'
    },
    message2500: {
      en: 'Message (limit 2,500 characters)',
      fr: 'Message (limit 2,500 characters) (fr)'
    },
    additionalInfo: {
      en: 'Additional information (limit 2,500 characters)',
      fr: 'Additional information (limit 2,500 characters) (fr)'
    },
    expectedPurchaseDate: {
      en: 'Expected Purchase Date',
      fr: 'Expected Purchase Date (fr)'
    },
    buildName: {
      en: 'Build Name',
      fr: 'Build Name (fr)'
    },
    recipientName: {
      en: "Recipient's Name",
      fr: "Recipient's Name (fr)"
    },
    recipientEmail: {
      en: "Recipient's Email Address",
      fr: "Recipient's Email Address (fr)"
    },
    recipientPhone: {
      en: "Recipient's Phone Number",
      fr: "Recipient's Phone Number (fr)"
    },
  },
  placeholder: {
    model: {
      en: 'Please choose a model',
      fr: 'Please choose a model (fr)'
    },
    model2: {
      en: 'Mazda model',
      fr: 'Mazda model (fr)'
    },
    modelYear: {
      en: 'Model year (select model first)',
      fr: 'Model year (select model first) (fr)'
    },
    subject: {
      en: 'Select Email Subject Content',
      fr: 'Select Email Subject Content (fr)'
    }
  },
  select: {
    expectedPurchaseOptions: [
      {
        en: "Within a month",
        fr: "Within a month (FR)",
      },
      {
        en: "Within 3 months",
        fr: "Within 3 months (FR)",
      },
      {
        en: "Within 6 months",
        fr: "Within 6 months (FR)",
      },
      {
        en: "Within 12 months",
        fr: "Within 12 months (FR)",
      },
      {
        en: "Over 12 months",
        fr: "Over 12 months (FR)",
      },
      {
        en: "Not sure",
        fr: "Not sure (FR)",
      },
    ],
    emailSubjects: [
      {
        en: "Accessibility",
        fr: "Accessibilité",
      },
      {
        en: "Change of address/Update of ownership",
        fr: "Changement d’adresse / Mise à jour du propriétaire",
      },
      {
        en: "CONNECTED VEHICLE",
        fr: "VÉHICULE CONNECTÉ",
      },
      {
        en: "General inquiries",
        fr: "Demandes générales",
      },
      {
        en: "MARKETING/SALES",
        fr: "MARKETING / VENTE",
      },
      {
        en: "MAZDA STORIES MAGAZINE",
        fr: "MAGAZINE MAZDA MONDE",
      },
      {
        en: "MYMAZDA APP",
        fr: "APPLICATION MYMAZDA",
      },
      {
        en: "Product information",
        fr: "Informations sur les produits",
      },
      {
        en: "RECALL",
        fr: "RAPPEL",
      },
      {
        en: "Recall reimbursement plan",
        fr: "Plan de remboursement des rappels",
      },
      {
        en: "Service/Warranty inquiries",
        fr: "Demandes de service et de garantie",
      }
    ],
  },
  checkboxes: {
    services: {
      maintenance: {
        en: "Scheduled Maintenance Service",
        fr: "Scheduled Maintenance Service (FR)",
      },
      brakeRepair: {
        en: "Brake Inspection/Repair",
        fr: "Brake Inspection/Repair (FR)",
      },
      windshieldRepair: {
        en: "Windshield Repair",
        fr: "Windshield Repair (FR)",
      },
      wheelAlignment: {
        en: "Wheel Alignment",
        fr: "Wheel Alignment (FR)",
      },
      tireRotation: {
        en: "Tire Rotation",
        fr: "Tire Rotation (FR)",
      },
      tireInstallation: {
        en: "Installation of Seasonal Tires",
        fr: "Installation of Seasonal Tires (FR)",
      },
      tireInspection: {
        en: "Tire Inspection/Replacement",
        fr: "Tire Inspection/Replacement (FR)",
      },
      other: {
        en: "Other",
        fr: "Other (FR)",
      },
    },
  }
}

export default formLang;